import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetExpenseByCategoryQuery } from "../../../services/Reports";
import {
  getExpenseByCategoryRequest,
  getExpenseByCategoryFailure,
  getExpenseByCategorySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allExpenseByCategory,
    isLoading: expenseByCategoryLoading,
    isError: expenseByCategoryError,
  } = useGetExpenseByCategoryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.expenseByCategoryPageNo,
    pageSize: state.expenseByCategoryPageSize,
    fromDate: new Date(state.expenseByCategoryFromDate).toLocaleDateString(),
    toDate: new Date(state.expenseByCategoryToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (expenseByCategoryLoading) {
      dispatch(getExpenseByCategoryRequest());
    }
    if (expenseByCategoryError) {
      dispatch(getExpenseByCategoryFailure(expenseByCategoryError));
    }
    if (allExpenseByCategory) {
      dispatch(
        getExpenseByCategorySuccess({
          data: allExpenseByCategory.data.expenseByCategory[0].data || [],
          totalPages:
            allExpenseByCategory.data.expenseByCategory[0].metadata[0]?.total ||
            0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allExpenseByCategory,
    profileData,
    state.expenseByCategoryFromDate,
    state.expenseByCategoryToDate,
    state.expenseByCategoryPageNo,
    state.expenseByCategoryPageSize,
  ]);
  return <></>;
};
export default Content;
